import * as amplitude from '@amplitude/analytics-browser'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ToastType } from 'ui'
import { useTranslation } from 'react-i18next'
import { useCorrectoApi, useToast } from '../../../contexts'
import {
  AuthType,
  LOCAL_STORAGE_AUTH_TYPE,
} from '../../../clients/CorrectoApiClient'

export const OauthGoogle = () => {
  const location = useLocation()
  const correctoApi = useCorrectoApi()
  const toastManager = useToast()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const searchParams = new URLSearchParams(location.hash)

  const accessToken = searchParams.get('access_token')

  useEffect(() => {
    if (!accessToken) return

    correctoApi
      .convertToken(accessToken)
      .then(response => {
        if (response.ok) {
          amplitude.setUserId(response.body.user.uuid)
          navigate('/projects')
          localStorage.setItem(LOCAL_STORAGE_AUTH_TYPE, AuthType.Google)
        } else {
          toastManager.showToast(
            ToastType.Danger,
            t('Se ha producido un error al en la authenticación con google'),
          )
          localStorage.removeItem(LOCAL_STORAGE_AUTH_TYPE)
          navigate('/login')
          throw new Error(JSON.stringify(response))
        }
      })
      .catch((error: unknown) => {
        throw error
      })
  }, [accessToken])

  return null
}
